import {Component, inject, OnInit} from '@angular/core';
import {
    HealthChartConfiguration, HealthChartPeriod,
    HealthDataType,
} from '../../../../../../models/health.models';
import {NavigationService} from '../../../../../../services/navigation.service';
import {HealthDataPageComponent} from '../../../../../../components/health-data-page/health-data-page.component';
import {dataType} from "terra-api/lib/esm/API/Data";

@Component({
    selector: 'app-blood-pressure-diastolic',
    standalone: true,
    imports: [HealthDataPageComponent],
    templateUrl: './blood-pressure-diastolic-page.component.html',
    styleUrl: './blood-pressure-diastolic-page.component.css',
})
export default class BloodPressureDiastolicPageComponent implements OnInit {
    #navigationService = inject(NavigationService);

    healthDataLabel = 'Pressione Arteriosa Diastolica';
    chartLabel = 'Pressione Arteriosa Diastolica';
    chartConfiguration: HealthChartConfiguration = {
        [HealthChartPeriod.day]: 'bubble',
        [HealthChartPeriod.week]: 'bar',
        [HealthChartPeriod.month]: 'bar',
    }
    heightHealthDataType = HealthDataType.BLOOD_PRESSURE_DIASTOLIC;
    hasTwoDecimals = false;
    payloadTypes: dataType[] = ['body'];

    ngOnInit(): void {
        this.#navigationService.saveCurrentRoute();
    }
}
